import { toast } from "react-toastify";
import { ProjectDataQry, ProjectListAndStatusesQry } from "api/queries";

export const projectSideEffects = {
  mutations: {
    modifyProject: (result, args, cache, info) => {
      const id = args.input?.id;

      if (result?.modifyProject?.status !== "SUCCESS") {
        toast.error("Something went wrong");
      }

      if (id) {
        if (info?.variables?.projectListQueryParams) {
          cache.updateQuery(
            {
              query: ProjectListAndStatusesQry,
              variables: info.variables.projectListQueryParams,
            },
            (data) => {
              return {
                ...data,
                currentUser: {
                  ...data.currentUser,
                  projectList: {
                    ...data.currentUser?.projectList,
                    items: data?.currentUser?.projectList?.items?.map((item) =>
                      item.id === id
                        ? {
                            ...item,
                            ...args.input,
                            status:
                              item.status.status === args.input.status
                                ? item.status.status
                                : data?.projectStatuses?.find(
                                    (i) => i.status === args.input.status,
                                  ),
                          }
                        : item,
                    ),
                  },
                },
              };
            },
          );
        } else {
          cache.updateQuery(
            {
              query: ProjectDataQry,
              variables: {
                input: { id, languageCode: info.variables.input.languageCode },
              },
            },
            (data) => {
              data.projectData = { ...data.projectData, ...args.input };
              return data;
            },
          );
        }
      }
    },
  },
  optimistic: {
    // The reason why this is disabled is because it may feel too fast for the user
    // and it may not be clear that the project has been updated.
    // modifyProject: () => ({
    //   __typename: "OperationResultType",
    //   status: "SUCCESS",
    //   message: "Project has been updated successfully",
    // }),
  },
};
